import { motion } from "framer-motion";
import { PROCESS, fadeUp } from "./content";

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-36 bg-bone" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            className="lg:col-span-4"
          >
            <span className="overline text-ink-soft">How it works</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight leading-[1.03] text-forest">
              Simple to start. Safe to run.
            </h2>
            <p className="mt-6 text-ink-soft leading-relaxed">
              From first enquiry to cover in your surgery — a clear, low-friction process built
              around how your practice already works.
            </p>
          </motion.div>

          <div className="lg:col-span-8 lg:pl-10 lg:border-l border-surface-alt">
            {PROCESS.map((step, i) => (
              <motion.div
                key={step.no}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                variants={fadeUp}
                custom={i}
                className="flex gap-6 md:gap-10 py-8 border-b border-surface-alt last:border-b-0 group"
                data-testid={`process-step-${step.no}`}
              >
                <span className="font-mono-label text-sm text-sage pt-1 w-10 shrink-0">
                  {step.no}
                </span>
                <div className="flex-1 flex flex-col md:flex-row md:items-baseline gap-2 md:gap-10">
                  <h3 className="font-display text-2xl md:text-3xl tracking-tight text-forest md:w-1/3 transition-transform duration-300 group-hover:translate-x-1">
                    {step.title}
                  </h3>
                  <p className="text-ink-soft leading-relaxed md:flex-1">{step.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
